angular
  .module("mobilezuz")
  .service("GgMapMobileService", [
    "GOOGLE_MAP_MOBILE_EVENTS",
    "GOOGLE_MAP_ADDRESS_TYPES",
    "gMapAbstractService",
    "AddressService",
    service,
  ]);

/**
 * @typedef {Object} MGeocodeExtra
 * @property {string} featureName // building/area name
 * @property {string} premises    // similar to featureName but rarely used
 * @property {string[]} lines     // formatted full address
 */

/**
 * @typedef {Object} MGeocodePosition
 * @property {number} lat
 * @property {number} lng
 */

/**
 * @typedef {Object} MGeocode         // M presents for mobile
 * @property {string} subThoroughfare // address number
 * @property {string} thoroughfare    // street
 * @property {string} subAdminArea    // district
 * @property {string} adminArea       // city/province/state
 * @property {string} locality        // same level as adminArea
 * @property {string} country
 * @property {string} countryCode
 * @property {string} locale
 * @property {MGeocodeExtra} extra
 * @property {MGeocodePosition} position
 */

function service(
  GOOGLE_MAP_MOBILE_EVENTS,
  GOOGLE_MAP_ADDRESS_TYPES,
  gMapAbstractService,
  AddressService
) {
  var self = this;
  var events = {
    onSelectAutocompleteOption: "onSelectAutocompleteOption",
  };

  angular.extend(self, gMapAbstractService);

  angular.extend(self, {
    events: events,

    initMap: initMap,
    initMarker: initMarker,
    initInfoWindow: initInfoWindow,

    reverseGeocode: reverseGeocode,
    geocoding: geocoding,
    extractInfoFromAddrComponents: extractInfoFromAddrComponents,

    moveCamera: moveCamera,
    moveMapMoveMarkerListener: moveMapMoveMarkerListener,
    clickMarkerTogglePopupListener: clickMarkerTogglePopupListener,
  });

  /**
   * @param {MGeocodePosition} latLng
   * @returns {MGeocode}
   */
  function reverseGeocode(latLng) {
    return new Promise(function (resolve) {
      plugin.google.maps.Geocoder.geocode(
        {
          position: latLng,
        },

        function (geocodes) {
          resolve(geocodes[0]);
        }
      );
    });
  }

  function geocoding(address, languageId) {
    return AddressService.geocodeByGgMapApi({ address: address, languageId: languageId }).then(
      function (res) {
        if (!res || !res.results | !res.results.length) {
          return [];
        }

        return _mapGeocodesToMGeocodes(res.results);
      }
    );
  }

  /**
   * @param {Geocode[]} geocodes
   * @returns {MGeocodes[]}
   */
  function _mapGeocodesToMGeocodes(geocodes) {
    var addresses = [];

    angular.forEach(geocodes, function (geocode) {
      var adrsCpnLastIndex = geocode.address_components.length - 1;

      /** @type {MGeocode} */
      var item = {
        position: {
          lat: geocode.geometry.location.lat,
          lng: geocode.geometry.location.lng,
        },

        locality: geocode.address_components[2].long_name,
        country: geocode.address_components[adrsCpnLastIndex].long_name,
        countryCode: geocode.address_components[adrsCpnLastIndex].short_name,
        extra: {
          featureName: geocode.formatted_address.split(", ")[0],
          lines: [geocode.formatted_address],
        },
      };

      addresses.push(item);
    });

    return addresses;
  }

  /**
   * @param {Element} mapRef
   * @param {*} options
   * @returns {Promise<*>} map
   */
  function initMap(mapRef, options) {
    if (!mapRef || !location) {
      return;
    }

    return new Promise(function (resolve) {
      var map = plugin.google.maps.Map.getMap(mapRef, options);

      map.one(GOOGLE_MAP_MOBILE_EVENTS.MAP_READY, function (map) {
        resolve(map);
      });
    });
  }

  function moveCamera(map, location) {
    map.moveCamera({
      target: location,
    });
  }

  /**
   *
   * @param {*} map
   * @param {*} marker
   * @param {Function} callback
   * @returns {void}
   */
  function moveMapMoveMarkerListener(map, marker, callback) {
    if (!map || !marker) {
      return;
    }

    map.on(GOOGLE_MAP_MOBILE_EVENTS.CAMERA_TARGET_CHANGED, function (location) {
      marker.setPosition(location);
    });

    map.on(GOOGLE_MAP_MOBILE_EVENTS.CAMERA_MOVE_END, function (camera) {
      reverseGeocode(camera.target).then(function (geocode) {
        callback(geocode);
      });
    });
  }

  /**
   *
   * @param {*} map
   * @param {MGeocodePosition} location
   * @returns marker
   */
  function initMarker(map, location) {
    if (!map || !location) {
      return;
    }

    var options = {
      position: location,
    };

    return map.addMarker(options, function (marker) {
      marker.showInfoWindow();
      return marker;
    });
  }

  /**
   * @param {Map} map
   * @param {MGeocodePosition} location
   * @returns
   */
  function moveCamera(map, location) {
    if (!map || !location) {
      return;
    }

    map.moveCamera({
      target: location,
    });
  }

  /**
   *
   * @param {string} html
   * @returns infoWindow
   */
  function initInfoWindow(html) {
    var infoWindow = new plugin.google.maps.HtmlInfoWindow();
    infoWindow.setContent(html);

    return infoWindow;
  }

  /**
   * @param {{
   * marker: any
   * infoWindow: any
   * }} param0
   */
  function clickMarkerTogglePopupListener(param0) {
    var marker = param0.marker;
    var infoWindow = param0.infoWindow;

    if (!marker) {
      return;
    }

    marker.addEventListener(GOOGLE_MAP_MOBILE_EVENTS.MARKER_CLICK, function () {
      infoWindow.open(marker);
    });
  }

  /**
   * @param {AddressComponents[]} addressComponents
   * @returns {{houseNumber: string, route: string, city: string, country: string, countryCode: string, zipCode: string}}
   */
  function extractInfoFromAddrComponents(addressComponents) {
    var initialResult = {
      houseNumber: "",
      route: "",
      city: "",
      country: "",
      zipCode: "",
      countryCode: "",
    };
    return addressComponents.reduce(function (result, component) {
      var types = component.types;
      var longName = component.long_name;
      var shortName = component.short_name;

      types.forEach(function (type) {
        switch (type) {
          case GOOGLE_MAP_ADDRESS_TYPES.STREET_NUMBER:
          case GOOGLE_MAP_ADDRESS_TYPES.PREMISE: {
            result.houseNumber = longName;
            break;
          }
          case GOOGLE_MAP_ADDRESS_TYPES.ROUTE: {
            result.route = longName;
            break;
          }
          case GOOGLE_MAP_ADDRESS_TYPES.LOCALITY:
          case GOOGLE_MAP_ADDRESS_TYPES.SUB_LOCALITY:
          case GOOGLE_MAP_ADDRESS_TYPES.NEIGHBORHOOD:
          case GOOGLE_MAP_ADDRESS_TYPES.POSTAL_TOWN: {
            result.city = longName;
            break;
          }
          case GOOGLE_MAP_ADDRESS_TYPES.COUNTRY: {
            result.country = longName;
            result.countryCode = shortName;
            break;
          }
        }
      });
      return result;
    }, initialResult);
  }
}
